import { rumErrorCtx } from '@web-platform/browser-rum';
import { isPaxUser } from 'helper/grab-id-auth-helper';
import { isUsingPaxPersonalPayments } from 'helper/user';

export const getDefaultErrorContext = () => {
  return rumErrorCtx()
    .custom('isPaxUser', isPaxUser())
    .custom('isPersonalProfile', isUsingPaxPersonalPayments())
    .build();
};

export default {};
